module.exports = __webpack_public_path__ + "static/shutterstock_1025765096-4bf603c9d70e50112d6955e1d2ca9cfc.mp4";